module.exports = __webpack_public_path__ + "img/loading2.d09d5e3e.gif";